import { useTranslation } from 'react-i18next';
import { useOnboarding } from './OnboardingContext';

export function ProgressIndicator() {
  const { t } = useTranslation();
  const { stepIndex, totalSteps, currentStep } = useOnboarding();
  
  // Don't show on welcome, account-type, or success screens
  if (currentStep === 'welcome' || currentStep === 'account-type' || currentStep === 'success' || currentStep === 'corporate-success') {
    return null;
  }

  // Adjust for welcome and account-type screens (first 2 steps)
  const adjustedIndex = Math.max(0, stepIndex - 2);
  const adjustedTotal = Math.max(1, totalSteps - 1); // Exclude account-type from count
  const percentage = Math.round(((adjustedIndex + 1) / adjustedTotal) * 100);

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-3 py-3 sm:py-4 px-12">
      <span className="text-xs sm:text-sm font-medium text-muted-foreground whitespace-nowrap">
        {t('common.step', { current: adjustedIndex + 1, total: adjustedTotal })}
      </span>
      <div className="w-12 sm:w-16 h-1.5 bg-secondary rounded-full overflow-hidden flex-shrink-0">
        <div 
          className="h-full bg-primary rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-xs sm:text-sm font-medium text-primary whitespace-nowrap">
        {percentage}%
      </span>
    </div>
  );
}
